import {Component, ViewChildren, QueryList, ElementRef, Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-station-reg-code',
    templateUrl: './station-reg-code.component.html',
    styleUrls: ['./station-reg-code.component.scss']
})
export class StationRegCodeComponent {
    @Output() ready = new EventEmitter<boolean>();

    @ViewChildren('digitInput') inputs!: QueryList<ElementRef>;

    codeForm: FormGroup;
    digits = Array(4); // For 6 input fields

    constructor(private fb: FormBuilder) {
        this.codeForm = this.fb.group({
            digit0: ['', [Validators.required, Validators.pattern(/^\d$/)]],
            digit1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
            digit2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
            digit3: ['', [Validators.required, Validators.pattern(/^\d$/)]]
        });
    }

    moveFocus(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;

        // Ensure the entered value is a digit
        if (/^\d$/.test(input.value) && index < 5) {
            const nextInput = this.inputs.toArray()[index + 1]?.nativeElement as HTMLInputElement;
            nextInput?.focus();
        }

        // If it's the last box, blur to indicate completion
        if (index === 3 && /^\d$/.test(input.value)) {
            input.blur();
        }

        // Clear the value if it's not a digit (optional cleanup)
        if (!/^\d$/.test(input.value)) {
            input.value = '';
        }


        const allDigitsFilled = (this.getCode().length == 4);
        this.ready.emit(allDigitsFilled);
    }

    clearInput(index: number): void {
        const control = this.codeForm.get(`digit${index}`);
        if (control) {
            control.setValue(''); // Clear the value of the input
        }
        this.ready.emit(false);
    }

    getCode(): string {
        const values = Object.keys(this.codeForm.controls).map(key => this.codeForm.get(key)?.value || '');
        return values.join('');
    }
}
